<div class="bottom-nav">
  <div class="left-side">
    <div class="nav-item" [class]="isActive('home')" (click)="navigateTo('/company-dashboard/home')">
      <i class="fa fa-home"></i>
      <span>Home</span>
    </div>
    <div class="nav-item" [class]="isActive('broadcast-request')" (click)="navigateTo('/company-dashboard/create-shifts')">
      <i class="fa fa-bullhorn"></i>
      <span>New Shift</span>
    </div>
  </div>
  <div class="logo-container">
    <img src="assets/images/staffy-logo-icon.png" alt="logo" class="logo">
  </div>
  <div class="right-side">
    <div class="nav-item" [class]="isActive('shift-requests')" (click)="navigateTo('/company-dashboard/shift-requests/unfilled/all')">
      <i class="fa fa-hand-paper"></i>
      <span>Requests</span>
    </div>
    <div class="nav-item" [class]="isActive('previous-staffies')" (click)="navigateTo('/company-dashboard/previous-staffies')">
      <i class="fa fa-history"></i>
      <span>Previous</span>
    </div>
  </div>
</div>